import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './Prose.module.css';

export interface ProseProps {
  children: ReactNode;
  align?: 'start' | 'center';
  /** Tamano del cuerpo. `sm` para los bloques densos de los mockups. */
  size?: 'sm' | 'md';
  className?: string;
}

/** Bloque de texto corrido con medida de lectura limitada. */
export function Prose({ children, align = 'start', size = 'md', className }: ProseProps) {
  return (
    <div
      className={cx('az-prose', styles.prose, styles[`align-${align}`], styles[`size-${size}`], className)}
    >
      {children}
    </div>
  );
}
